import { useState } from "react";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import CircularProgress from "@mui/material/CircularProgress";
import Radio from "@mui/material/Radio";
import { useDispatch, useSelector } from "react-redux";
import {
  actionInfoBulkDownload,
  actionInfoDownloadFormatUpdated,
} from "./InfoRedux";
import ListItemButton from "@mui/material/ListItemButton";

export default function DownloadDialog({
  open,
  onClose,
  bldrecnbr,
  floor,
  name,
}) {
  const titleStyle = { backgroundColor: "rgba(0, 0, 0, 0.05)" };
  const progressStyle = { position: "absolute", top: "50%", left: "45%" };
  const itemStyle = { textAlign: "center" };

  const fileDownloadFormat = useSelector(
    (state) => state.infoReducer.fileDownloadFormat,
  );
  const dispatch = useDispatch();
  const floorStr = floor ? `(Floor ${floor})` : "";
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setIsLoading(false);
    onClose();
  };

  const handleDownloadClick = (downloadType, buildFloor) => () => {
    setIsLoading(true);
    dispatch(
      actionInfoBulkDownload(downloadType, bldrecnbr, buildFloor, handleClose),
    );
  };

  const handleRadioChange = (event) => {
    dispatch(actionInfoDownloadFormatUpdated(event.target.value));
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="data-download" open={open}>
      <DialogTitle style={titleStyle}>
        Data Download - {name} {floorStr}
      </DialogTitle>
      <DownloadFormatInput
        fileDownloadFormat={fileDownloadFormat}
        handleRadioChange={handleRadioChange}
      />
      <List>
        <ListItemButton
          role="listitem"
          onClick={handleDownloadClick("room", floor)}
          disabled={isLoading}
        >
          <ListItemText primary={"Room Data"} style={itemStyle} />
        </ListItemButton>
        <ListItemButton
          role="listitem"
          onClick={handleDownloadClick("perrol", floor)}
          disabled={isLoading}
        >
          <ListItemText primary={"Occupant Data"} style={itemStyle} />
        </ListItemButton>
        <ListItemButton
          role="listitem"
          onClick={handleDownloadClick("occdept", floor)}
          disabled={isLoading}
        >
          <ListItemText primary={"Department Data"} style={itemStyle} />
        </ListItemButton>
      </List>
      {isLoading && <CircularProgress style={progressStyle} />}
    </Dialog>
  );
}

function DownloadFormatInput({ fileDownloadFormat, handleRadioChange }) {
  const style = { textAlign: "center" };

  return (
    <div style={style}>
      <label htmlFor="file-format-csv">CSV</label>
      <Radio
        checked={fileDownloadFormat === "csv"}
        onChange={handleRadioChange}
        value="csv"
        name="radio-button-demo"
        slotProps={{
          input: {
            "aria-label": "CSV format",
            id: "file-format-csv",
          },
        }}
        color="primary"
      />
      <label htmlFor="file-format-xlsx">Excel</label>
      <Radio
        checked={fileDownloadFormat === "xlsx"}
        onChange={handleRadioChange}
        value="xlsx"
        name="radio-button-demo"
        slotProps={{
          input: {
            "aria-label": "Excel format",
            id: "file-format-xlsx",
          },
        }}
        color="primary"
      />
    </div>
  );
}
